<script>
    import R, {LOADER} from "../lib/requests";
    import Modal from "../components/modal/Modal.svelte";
    import TagItem from "./TagItem.svelte";

    export let objectType;
    export let closeCallback;

    let tags = [];
    let isDirty = false;

    const load = () => {
        const onSuccess = result => {
            tags = result.filter(x => x.object_type == objectType);
        }

        const onFailure = err => {
        };

        R.handle(R.tag.index, {}, onSuccess, onFailure);
    }

    const onAdd = () => {
        if (tags.filter(x => x.id == 0).length > 0) {
            return;
        }

        tags = [...tags, {
            id: 0,
            name: '',
            color: '',
            object_type: objectType
        }];
    }

    const onChange = ({detail}) => {
        let item = tags.find(x => x.id == detail.id);
        if (item) {
            item.name = detail.name;
            item.color = detail.color;
        } else {
            tags = [...tags, detail];
        }
        isDirty = true;
    }

    const onDelete = ({detail}) => {
        tags = tags.filter(x => x.id != detail.id);
        isDirty = true;
    }

    const onCancelEdit = () => {
        tags = tags.filter(x => x.id != 0);
    }

    const close = (param) => {
        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(isDirty ? tags : null);
        }, 200);
    }

    load();
</script>

<Modal title="Ετικέτες" icon="tag" closeOnEscape="{ true }" on:close="{ close }">
    <div slot="body">
        {#each tags as item}
            <TagItem tag={item} {objectType} on:change={onChange} on:delete={onDelete} on:cancel={onCancelEdit}/>
        {/each}
        <button class="btn btn-default btn-block" on:click={onAdd}>
            Νέα ετικέτα
        </button>

        <hr class="full-hr">
        <div class="text-end">
            <div class="btn btn-link" on:click="{ () => close() }">Κλείσιμο</div>
        </div>
    </div>
</Modal>